module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAYAAAAehFoBAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADjSURBVHgB7dKxDYMwFIThFxfMQUbJJlSIkRAVm2SUeA4KlBxCEUJgwD5LFPc1toyx/8JmIiIiInJfj9DHuq4/GIdhePV97y2jqqrKoijemHdd99zb5+zYdBAOtEwWseXR3mCwc+71G7xljF7F+vnOXcEnAU3TlOM4/g9kPo+t2LZtfeifw2DIER0TC6eCgRkdGwung4ERnRILl4IhJTo1Fi4HQ0w0IxaiguFKNCsWooPhTDQzFpKCIRTNjoXkYNiKxjo7FijBsI6el6c5KxZowbCKBmosUINhEW3sWBERERG5uy9IFuIlVYcYUQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/back.png
// module id = P9/e
// module chunks = 0